export const BROWSER_ROUTES = {
	// Auth routes
	LOGIN: "/sign-in",
	SIGNUP_VERIFY_OTP: "/sign-up/verify-otp",
	SIGNUP_RESET_PASSWORD: "/sign-up/reset-password",
	VERIFY_EMAIL: "/verify-email",
	FORGET_PASSWORD: "/forget-password",
	VERIFY_OTP: "/verify-otp",
	RESET_PASSWORD: "/reset-password",
	SET_PASSWORD: "/set-password/:id",
	UNAUTHORIZED: "/unauthorized",
	SERVER_ERROR: "/500",
	NOT_FOUND: "/404",
	ABOUT: "/about",
	// Legal routes
	PRIVACY_POLICY: "/privacy-policy",
	TERMS_AND_CONDITIONS: "/terms-and-conditions",
	// Dashboard routes
	DASHBOARD: "/",
	RESULT_PROCESSING: "/result-processing",
	DATASHEET: "/datasheet",
	API_DOCUMENTATION: "/api-documentation",
	// Legacy route (keeping for backward compatibility)
	DATA_SHEET: "/date-sheet",
	API: "/api",
} as const;
